// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.columnTree[data-v-42419888] {\n  height: calc(100vh - 130px) !important;\n}\n", ""]);
// Exports
module.exports = exports;
